import { render, staticRenderFns } from "./homeHeaderMenuChildren.vue?vue&type=template&id=200e9a76&"
import script from "./homeHeaderMenuChildren.vue?vue&type=script&lang=js&"
export * from "./homeHeaderMenuChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/homeHeaderMenuChildren.vue"
export default component.exports